const STORAGE_KEY = 'pmw_ai_chat_next_suggestion';
const MAX_ENTRIES = 20;

type NextSuggestionEntries = [string, string][];

function readStore(): Map<string, string> {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return new Map();
    }
    return new Map(JSON.parse(stored) as NextSuggestionEntries);
  } catch (e) {
    console.error(e);
    return new Map();
  }
}

function writeStore(store: Map<string, string>): void {
  try {
    const entries = Array.from(store.entries()).slice(-MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch (e) {
    console.error(e);
  }
}

export function getStoredNextSuggestion(chatId: string): string | null {
  return readStore().get(chatId) ?? null;
}

export function setStoredNextSuggestion(chatId: string, suggestion: string): void {
  const store = readStore();
  store.delete(chatId);
  store.set(chatId, suggestion);
  writeStore(store);
}

export function clearStoredNextSuggestion(chatId: string): void {
  const store = readStore();
  if (!store.delete(chatId)) {
    return;
  }

  writeStore(store);
}
